module.exports = __webpack_public_path__ + "img/library-cta-front.578ed163.svg";